// import lottie from 'lottie-web'
import gsap from 'gsap'

export const homeBanner = () => {

	let el = document.querySelector('[data-animation="homepage-banner"]')

	if (!el) return

	let video = el.querySelector('[data-el="video"]')

	video.play()

	if (window.innerWidth > 1280) {

		let wrapper = el.querySelector('[data-el="video-wrapper"]'),
			heading = el.querySelector('[data-el="heading"]'),
			detail = el.querySelector('[data-el="detail"]'),
			overlay = el.querySelector('[data-el="overlay"]'),
			text = el.querySelector('[data-el="text"]')


		let parentRect = el.parentElement.getBoundingClientRect(),
			rect = wrapper.getBoundingClientRect()

		let top = rect.top - parentRect.top,
			left = rect.left - parentRect.left,
			end = '+=' + (window.innerHeight * 0.7)

		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				start: 'top top',
				end: end,
				pin: true,
				pinSpacing: true,
				scrub: true,
				anticipatePin: 1,
				// markers: true,
			}
		});

		tl.fromTo(wrapper, {
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
		}, {
			top: (top + 2) * -1,
			left: (left + 2) * -1,
			width: window.innerWidth + 4,
			height: window.innerHeight + 4,
			ease: 'power1.out'
		})

		tl.fromTo(heading, {
			y: detail.offsetHeight,
		}, {
			y: 0,
		}, '<')

		tl.fromTo(detail, {
			y: detail.offsetHeight,
			opacity: 0,
		}, {
			y: 0,
			opacity: 1,
		}, '<')

		tl.to(wrapper, {
			duration: 0.15
		})

		let lower = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				start: 'bottom bottom',
				end: 'bottom top',
				scrub: true,
				// markers: true,
			}
		})

		lower.fromTo(overlay, {
			opacity: 0,
		}, {
			opacity: 1,
		})

		lower.fromTo(video, {
			y: 0,
		}, {
			y: window.innerHeight * 0.5,
			ease: 'linear',
		}, '<')

		lower.fromTo(text, {
			y: 0,
		}, {
			y: window.innerHeight * 0.3,
			ease: 'linear',
		}, '<')
	}
}

export default () => { }